/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IReportsExportViewProps } from './reports-export';

export default (props: IReportsExportViewProps) => {
    const { heading, reportsList, moduleProps, modal } = props;
    return (
        <Module {...moduleProps}>
            {heading}
            {modal}
            {reportsList}
        </Module>
    );
};
